export const notAuthorizedUrl = [
    '/merchants/current',
    '/currencies/pairs',
    '/orders/estimateRates',
    '/orders/userDetails',
];
export const BLOCKED_USER_ERROR_CODE = 403;
